import { NmLoader } from './NmLoader';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
export function NotificationLoadMore({ hasMore, loading, failed, onLoad, itemCount }: { hasMore: boolean; loading: boolean; failed: boolean; onLoad: () => Promise<void>; itemCount: number }) {
  const { t } = useTranslation(); const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const node = ref.current;
    if (!node || !hasMore || loading || failed || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) void onLoad(); }, { rootMargin: '0px 0px 250px 0px' });
    observer.observe(node); return () => observer.disconnect();
  }, [hasMore, loading, failed, onLoad, itemCount]);
  if (!hasMore) return null;
  return <div ref={ref} style={{ minHeight: 60, display: 'grid', placeItems: 'center', padding: 12 }}>
    <button type="button" disabled={loading} onClick={() => void onLoad()} style={{ minHeight: 40, border: 0, borderRadius: 10, background: 'var(--surface-0)', color: 'var(--fg-1)', padding: '8px 16px', font: 'inherit', cursor: 'pointer' }}>{loading ? <NmLoader size="xs" inline label={t('notificationPaging.loading')} /> : t(failed ? 'notificationPaging.retry' : 'notificationPaging.more')}</button>
  </div>;
}
